import React, { useState, useEffect } from 'react';
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import '../../../Styles/Interface/Events/DatePickerStyles.css';

dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

const DateRangeSelector = ({ handleEventDate, typeOfEvent }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  // Function to fetch events
  const fetchEvents = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/events', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error("Error fetching events");
      }

      const data = await response.json();

      // Filter events based on event type
      let filteredEvents = [];

      if (typeOfEvent === 'inside') {
        filteredEvents = data.filter(event => event.eventType === 'inside')
          .map(event => ({
            start: dayjs(event.eventDateStart),
            end: dayjs(event.eventDateEnd),
            title: event.eventTitle
          }));
      } else if (typeOfEvent === 'outside') {
        filteredEvents = data.filter(event => event.eventType === 'outside')
          .map(event => ({
            start: dayjs(event.eventDateStart),
            end: dayjs(event.eventDateEnd),
            title: event.eventTitle
          }));
      }

      setEvents(filteredEvents);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [typeOfEvent]);

  // Function to check if a date is disabled (has events)
  const disabledDate = (current) => {
    // Can't select days before today
    if (current && current < dayjs().startOf('day')) {
      return true;
    }

    // Check if the date has events
    return events.some(event => {
      const eventDate = event.start;
      return current.format('YYYY-MM-DD') === eventDate.format('YYYY-MM-DD');
    });
  };

  // Create an array of hours outside the allowed range (8am-6pm)
  const getDisabledHours = () => {
    const hours = [];
    // Hours before 8am
    for (let i = 0; i < 8; i++) {
      hours.push(i);
    }
    // Hours after 6pm
    for (let i = 18; i < 24; i++) {
      hours.push(i);
    }
    return hours;
  };

  const disabledRangeTime = (_, type) => {
    return {
      disabledHours: () => getDisabledHours(),
      disabledMinutes: () => [], // Allow all minutes
      disabledSeconds: () => [] // Allow all seconds
    };
  };

  // Handle date range change
  const onChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      handleEventDate({
        start: dates[0].toDate(),
        end: dates[1].toDate()
      });
    }
  };

  return (
    <Space direction="vertical" size={12} className="date-range-wrapper">
      <RangePicker
        popupClassName="calendar-popup-override"
        disabled={loading}
        disabledDate={disabledDate}
        disabledTime={disabledRangeTime}
        showTime={{
          hideDisabledOptions: true,
          format: 'HH:mm',
          defaultValue: [dayjs('08:00', 'HH:mm'), dayjs('18:00', 'HH:mm')]
        }}
        format="YYYY-MM-DD HH:mm"
        onChange={onChange}
        placeholder={['Fecha inicio', 'Fecha fin']}
        style={{ width: '100%' }}
      />
    </Space>
  );
};

export default DateRangeSelector;